var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4812 36.124C60.4812 37.4239 59.9812 38.6739 59.0312 39.6739L34.0312 64.6739C32.0812 66.6239 28.9312 66.6239 26.9812 64.6739L1.98121 39.6739C0.0312077 37.7239 0.0312078 34.5739 1.98121 32.6239C3.93121 30.6739 7.08121 30.6739 9.03121 32.6239L30.4812 54.0739L51.9312 32.5739C53.8812 30.6239 57.0312 30.624 58.9812 32.5739C59.9812 33.5739 60.4812 34.824 60.4812 36.124Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8619 50.5739L24.8619 4.64895C24.8619 2.13466 27.3196 0.11145 30.3499 0.11145C33.3803 0.11145 35.8619 2.13466 35.8619 4.64895L35.8619 50.5936C35.8619 53.0882 33.4042 55.1115 30.3499 55.1114C27.2957 55.1114 24.8619 53.0882 24.8619 50.5739Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5d3414c1.svg";
export { ForwardRef as ReactComponent };